export default "__VITE_ASSET__BSNR3L70__"